import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { ViewState, CrudlStatus } from "../../../common/config/AppConstants";
import * as format from "../../../common/FormatFunctions";
import { ListValueDisplay } from "../../Common/ListValueDisplay";

export class CatalogueDisplay extends React.Component {
 

  render() {
    var bean = this.props.data;
    if (!format.isNotNull(bean)) {
      return <div></div>;
    }
    return (
      <div
        className="ui-g-12 card-round"
        onClick={e => {
          if (format.isFunction(this.props.onClick)) {
            this.props.onClick(CrudlStatus.VIEW, bean);
          }
        }}
      >
        <div className="ui-g-12">
          <h2>Catalogue Summary: </h2>
          <label />

          <div className="ui-g-2 row"></div>
          <div className="ui-g-8 row">
            <div className="ui-g-8 cell">
              {/* EXAMPLE
               <b style={{ float: "right" }}>Name: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Description: </b> */}
            </div>

            <div className="ui-g-8 cell">
              {/* EXAMPLE
              <label>{bean.name || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>{bean.description || "Not Set"}</label> */}

            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Catalogues/UI/CatalogueDisplay.js